import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

export const useTenantTour = () => {
  const { user } = useSelector((state) => state.landlordslice);
  const [shouldShowTour, setShouldShowTour] = useState(false);
  const [shouldShowWelcome, setShouldShowWelcome] = useState(false);
  const [resumeAtStep, setResumeAtStep] = useState(null);

  useEffect(() => {
    if (user?.data?.user?.user_id) {
      // Check if tour has been completed for this user
      const tourCompleted = localStorage.getItem(
        `tenant_tour_completed_${user.data.user.user_id}`
      );

      // Check if this is the user's first visit to the dashboard
      const firstVisit = localStorage.getItem(
        `tenant_first_visit_${user.data.user.user_id}`
      );

      // Show welcome banner if it hasn't been completed and this is a first visit
      if (!tourCompleted && !firstVisit) {
        setShouldShowWelcome(true);
        // Mark that user has visited the dashboard
        localStorage.setItem(
          `tenant_first_visit_${user.data.user.user_id}`,
          "true"
        );
      }
    }
  }, [user]);

  const startTour = () => {
    setShouldShowWelcome(false);
    setShouldShowTour(true);
    setResumeAtStep(null);
  };

  const endTour = () => {
    setShouldShowTour(false);
    setResumeAtStep(null);
  };

  const dismissWelcome = () => {
    setShouldShowWelcome(false);
    if (user?.data?.user?.user_id) {
      localStorage.setItem(
        `tenant_tour_completed_${user.data.user.user_id}`,
        "true"
      );
    }
  };

  const resetTour = () => {
    if (user?.data?.user?.user_id) {
      localStorage.removeItem(
        `tenant_tour_completed_${user.data.user.user_id}`
      );
      localStorage.removeItem(`tenant_first_visit_${user.data.user.user_id}`);
      setShouldShowTour(true);
      setShouldShowWelcome(false);
      setResumeAtStep(null);
    }
  };

  const resumeTourAtStep = (stepIndex) => {
    setShouldShowTour(true);
    setShouldShowWelcome(false);
    setResumeAtStep(stepIndex);
  };

  return {
    shouldShowTour,
    shouldShowWelcome,
    resumeAtStep,
    startTour,
    endTour,
    dismissWelcome,
    resetTour,
    resumeTourAtStep,
  };
};

export default useTenantTour;
